/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBackspace, faBarcode, faBox, faCalendar, faCheck, faCheckCircle, faCloudUploadAlt, faCode, faCross, faDollarSign, faEdit, faHome, faHSquare, faPeopleArrows, faPhone, faPlug, faQrcode, faRocket, faSave, faSearch, faTasks, faUser, faUserShield, faWarehouse } from "@fortawesome/free-solid-svg-icons"
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, Form, Image, InputGroup, Pagination, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import Datetime from "react-datetime";
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import _ from "lodash"
import { WaybillStatus } from "./WaybillPage"
//import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import CanadaFlag from '../../assets/img/flags/canada.svg';
import GermanyFlag from '../../assets/img/flags/germany.svg';
import FranceFlag from '../../assets/img/flags/france.svg';
import JapanFlag from '../../assets/img/flags/japan.svg';
import ItalyFlag from '../../assets/img/flags/italy.svg';
import ChinaFlag from '../../assets/img/flags/china.svg';
import PuPagination from "../../components/PuPagination"
import { Routes } from "../../routes"


import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';

import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { ApiSrc } from '../../resources/ApiSrc'
import { getUser } from "../../core/auth/authentication";
import { swal } from "sweetalert2/dist/sweetalert2";

var Barcode = require('react-barcode');

const moment = require('moment');

export default (props) => {

    const [user, setUser] = useState()
    useEffect(()=> {
        getUser().then(it=>{
            setUser(it)
            //console.log('>user', it)
            if(_.get(it, 'countryCode') != 855)
                setCountryCode(_.get(it, 'countryCode'))            
        })
    }, [])

    const [receivedAt, setReceivedAt] = useState()
    const [arrivedAt, setArrivedAt] = useState()
    const [width, setWidth] = useState()
    const [height, setHeight] = useState()
    const [length, setLength] = useState()
    const [weight, setWeight] = useState()
    const [volume, setVolume] = useState()
    const [freightFee, setFreightFee] = useState()
    const [status, setStatus] = useState()
    const [progressValue, setProgressValue] = useState();

    const [paid, setPaid] = useState()
    const [paidAmount, setPaidAmount] = useState()
    const [paidAt, setPaidAt] = useState()


    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [reference, setReference] = useState();
    const [phone, setPhone] = useState();
    const [accountNo, setAccountNo] = useState();
    const [shipmentType, setShipmentType] = useState('land');
    const [countryCode, setCountryCode] = useState(86)

    const [receiverWarehouse, setReceiverWarehouse] = useState();


    const dispatch = useDispatch();
    const waybillRes = useSelector((state) => state.waybill);
    //const waybills = _.get(waybillRes, "waybillList.data");
    const waybill = _.get(waybillRes, 'waybill')

    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms (5 seconds)
        
//    const accountNoPress = (e) => {   
//         clearTimeout(typingTimer);
//         setAccountNo(e.target.value)
//         if (e.target.value) {            
//             typingTimer = setTimeout(doneTyping, doneTypingInterval);
//         }
//    }

    //user is "finished typing," do something
    const doneTyping = () => {
        setReceiverWarehouse(undefined)
        if(accountNo == '' || accountNo == undefined) return
        PostRequest(ApiSrc.GET_USER_WAREHOUSE, { input: { accountNo: `${countryCode == 86 ? '0001111' : 'JOONAAK'}-${accountNo}`, countryCode } }).then(result => {
            GetResultObject(result, 'data', 200, (data) => {
                //setFirstName(_.get(data, '[0]receiver.firstName', ''))
                //setLastName(_.get(data, '[0]receiver.lastName', ''))
                //setPhone(_.get(data, '[0]receiver.phone', ''))     
                if(data.length > 0)           
                    setReceiverWarehouse(data[0])
            })
        })
    }

    useEffect(() => {
        doneTyping()
    }, [countryCode, accountNo])


    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            //Do whatever when esc is pressed
            props.onClose && props.onClose()
        }
        //  else  if (event.keyCode === 13) {
        //     doneTyping()
        // }
    }, [props]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);



    const onSave = () => {
        const body = {
            id: _.get(props, 'id'),
            status,
            receivedAt,
            arrivedAt,
            height,
            width,
            weight,
            length,
            volume,
            freightFee,
            paidAmount,
            paidAt,
            receiverWarehouseId: _.get(receiverWarehouse, 'id'),
            countryCode,
            reference,
        }

        if (paidAmount && paidAt) {
            body.paid = true
        }


        console.log('>> body', body)
        setProgressValue(30)
        PostRequest(ApiSrc.CREATE_WAYBILL, { input: { ...body }, token: null }).then(result =>
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(WaybillAction.createWaybillSuccess(data));
                let timer = setInterval(function () {
                    props.onClose && props.onClose(timer)
                }, 1000);
            },  error => {
                swal('error')
            })
        )
        //dispatch(WaybillAction.updateWaybill({input: {...body}, token: null}));
    }



    

    return (
        <>
            {
                progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
            }
            <Card>


                <Card.Body>
                    <Row>                        
                        <Col>
                            <Form.Label>Receiver Detail</Form.Label>
                            <Row>
                                
                                <Form.Group className="mb-4">
                                    <Form.Label>From Country</Form.Label>
                                    <InputGroup>
                                    {
                                        countryCode && (                                            
                                            <Form.Select 
                                                disabled={_.get(user,'countryCode') != 855}
                                                onChange={(e) => {
                                                    setCountryCode(e.target.value == "--Select--" ? undefined : e.target.value)
                                                }}>                                                                                            
                                                <option value={86} selected={countryCode == 86}>China</option>
                                                <option value={66} selected={countryCode == 66}>Thailand</option>
                                                <option value={84} selected={countryCode == 84}>Vietnam</option>        
                                            </Form.Select>
                                        )
                                     }
                                    
                                    
                                    </InputGroup>
                                </Form.Group>
                            
                                <Form.Group className="mb-4">
                                    <Form.Label>Account No</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text className={'bg-warning'}>
                                            <FontAwesomeIcon icon={faUser} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            autoFocus={true}                                          
                                            //onChange={accountNoPress}
                                            //onChange={(e) => { setAccountNo(e.target.value) }}
                                            onChange={(e) => { setAccountNo(e.target.value) }}
                                            value={accountNo}
                                        />
                                    </InputGroup>
                                </Form.Group>     

                                <Form.Group className="mb-4">
                                    <Form.Label>Reference</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text className={'bg-warning'}>
                                            <FontAwesomeIcon icon={faBarcode} />
                                        </InputGroup.Text>
                                        <Form.Control                                                                                                                              
                                            onChange={(e) => { 
                                                setReference(e.target.value) 
                                            }}
                                            value={reference}
                                        />
                                    </InputGroup>
                                </Form.Group>                                                                                   

                                <InputGroup>
                                    <Row>
                                        <Col>
                                            { _.get(receiverWarehouse, 'accountNo') && <Barcode value={_.get(receiverWarehouse, 'accountNo')} /> }
                                        </Col>
                                        <Col>
                                            { reference && <Barcode value={reference} /> }
                                        </Col>
                                    </Row>
                                    
                                </InputGroup>

                                {
                                    _.get(waybill, 'photo') && (
                                        <Form.Group className="mb-4">
                                            <img src={_.get(waybill, 'photo')} />
                                        </Form.Group>
                                    )
                                }

                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Form.Label>Good Detail</Form.Label>

                                <Form.Group className="mb-4">

                                    <Form.Label>Shipment Type</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faWarehouse} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            readOnly={true}
                                            required type="text"
                                            value={shipmentType} />
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>From</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faWarehouse} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            readOnly={true}
                                            required type="text"
                                            value={_.get(receiverWarehouse, 'warehouse.note')} />
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Row>
                                        <Col xs={12} sm={6} xl={4}>
                                            <Form.Label>Width(cm)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faBox} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    required type="number"
                                                    onChange={(e) => { setWidth(e.target.value) }}
                                                    value={width} />
                                            </InputGroup>
                                        </Col>
                                        <Col xs={12} sm={6} xl={4}>
                                            <Form.Label>Height(cm)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faBox} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    required type="number"
                                                    onChange={(e) => { setHeight(e.target.value) }}
                                                    value={height} />
                                            </InputGroup>
                                        </Col>
                                        <Col xs={12} sm={6} xl={4}>
                                            <Form.Label>Length(cm)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faBox} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    required type="number"
                                                    onChange={(e) => { setLength(e.target.value) }}
                                                    value={length} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Weight(kg)</Form.Label>

                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faBox} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            required type="number"
                                            onChange={(e) => { setWeight(e.target.value) }}
                                            value={weight} />
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Volume(cmb)</Form.Label>

                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faBox} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            required type="number"
                                            onChange={(e) => { setVolume(e.target.value) }}
                                            value={volume} />
                                    </InputGroup>
                                </Form.Group>


                                <Row>
                                    <Col xs={12} sm={6} xl={4}>
                                        <Form.Group className="mb-4">
                                            <Form.Label>Freight Fee($)</Form.Label>

                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faDollarSign} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    onChange={(e) => { setFreightFee(e.target.value) }}
                                                    required type="number"
                                                    value={freightFee} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>                                    
                                </Row>

                                

                            </Row>
                            {
                                progressValue === undefined && (
                                    <Form.Group className="mb-4 float-end">
                                        <Button className={"bg-danger"} onClick={() => { props.onClose && props.onClose() }}><FontAwesomeIcon icon={faBackspace} /> Cancel</Button>&nbsp;&nbsp;&nbsp;
                                        {
                                            (_.get(receiverWarehouse, 'id') && reference) && (<Button onClick={onSave}><FontAwesomeIcon icon={faSave} /> Save</Button>)
                                        }
                                        
                                    </Form.Group>
                                )
                            }
                        </Col>
                    </Row>

                </Card.Body>                
            </Card>
        </>
    )
}
